<template>
    <v-footer app dark :color="$vuetify.theme.themes.dark.primary" style="justify-content:center">
        <div class="footer-text">
            <span v-html="$t('footerText')"></span>
        </div>
    </v-footer>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

@media #{map-get($display-breakpoints, 'sm-and-up')} {
    .footer-text {
        font-size: 1.1rem;
    }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
    .footer-text {
        font-size: 0.5rem;
    }
}
</style>
